import { Lightning, Sparkle } from "@phosphor-icons/react";

export default function ModeToggle({ value, onChange }) {
  const options = [
    { id: "quick", label: "Quick", icon: Lightning },
    { id: "ai", label: "AI Realistic", icon: Sparkle },
  ];
  return (
    <div
      className="inline-flex p-1 rounded-lg border"
      style={{
        background: "var(--epx-elevated)",
        borderColor: "var(--epx-border)",
      }}
      data-testid="mode-toggle"
    >
      {options.map((o) => {
        const Icon = o.icon;
        const active = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              active
                ? "text-white"
                : "text-zinc-400 hover:text-white"
            }`}
            style={
              active
                ? {
                    background: "var(--epx-primary)",
                    boxShadow: "0 0 16px rgba(var(--epx-primary-rgb),0.40)",
                  }
                : undefined
            }
            data-testid={`mode-${o.id}`}
            aria-pressed={active}
          >
            <Icon size={14} weight={active ? "fill" : "regular"} />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
